var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.options),function(o,i){return _c('div',{staticClass:"card p-2 mb-2",class:{selected: _vm.answer === (o.number - 1)},staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.answer = o.number - 1}}},[_c('h6',{staticStyle:{"margin-bottom":"0"}},[_vm._v(_vm._s(o.number)+" "+_vm._s(o.sentence))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }